import {
    useOutlet,
} from 'react-router-dom';

export default function PageHub() {
    const currentOutlet = useOutlet()

    return currentOutlet;
}
